import { Error, RootState } from '@/store/types';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { ActionTree } from 'vuex';
import { Smart, SmartState } from './types';

export const actions: ActionTree<SmartState, RootState> = {
  get({ commit, state }): void {
    axios({
      url: '/devices',
      method: 'GET',
    }).then(
      (response: AxiosResponse) => {
        const payload: SmartState[] = response && response.data;
        commit('SMART_SUCCESS', payload);
      },
      (error: AxiosError) => {
        const payload: Error = new Error(error);
        commit('SMART_ERROR', payload);
      },
    );
  },
  add({ commit }, smart: Smart): Promise<undefined> {
    return new Promise((resolve, reject) => {
      axios({
        url: '/devices',
        method: 'PUT',
        data: smart,
      }).then(
        () => {
          resolve();
        },
        (error: AxiosError) => {
          const payload: Error = new Error(error);
          commit('SMART_ADD_ERROR', payload);
          reject();
        },
      );
    });
  },
  put({ commit }, smart: Smart): Promise<undefined> {
    return new Promise((resolve, reject) => {
      axios({
        url: `/devices/${smart._id}`,
        method: 'PUT',
        data: smart,
      }).then(
        () => {
          resolve();
        },
        (error: AxiosError) => {
          const payload: Error = new Error(error);
          commit('SMART_ADD_ERROR', payload);
          reject();
        },
      );
    });
  },
  delete({ commit }, _id: string): Promise<undefined> {
    return new Promise((resolve, reject) => {
      axios({
        url: `/devices/${_id}`,
        method: 'DELETE',
      }).then(
        () => {
          resolve();
        },
        (error: AxiosError) => {
          const payload: Error = new Error(error);
          commit('SMART_DELETE_ERROR', payload);
          reject();
        },
      );
    });
  },
  onSmart({ commit }, smart: Smart): any {
    axios({
      url: `/devices/${smart.mac}/connect/${smart.protocol}`,
      method: 'GET',
    }).then(
      (response: AxiosResponse) => {
        const payload: SmartState = response && response.data;
        commit('SMART_ON_SUCCESS', payload);
      },
      (error: AxiosError) => {
        const payload: Error = new Error(error);
        commit('SMART_ON_ERROR', payload);
      },
    );
  },
  syncSmart({ commit }, id: string): any {
    return new Promise((resolve, reject) => {
      axios({
        url: `/devices/${id}/sync`,
        method: 'POST',
        timeout: 30000,
      }).then(
        (response: AxiosResponse) => {
          resolve();
        },
        (error: AxiosError) => {
          const payload: Error = new Error(error);
          commit('SMART_SYNC_ERROR', payload);
          reject();
        },
      );
    });
  },
};
